export default "__VITE_ASSET__DPlLER9g__"